import { useEffect, useState } from "react";
import { usePopper } from "react-popper";
import InvoiceFilterModal from "../modals/invoice/InvoiceFilterModal";
import { useAuthStore } from "../../store/auth.store";
import number_format from "../../utils/number_format";
import { useTranslation } from "../../hooks/useTranslation";

export function DealFilterActual({ setFilter, filter }) {
  const { t } = useTranslation();
  const deleteFromFilter = (key) => {
    if (key === "current_state_id") {
      setFilter({
        ...filter,
        current_state_id: null,
      });
    } else {
      setFilter({
        ...filter,
        [key]: null,
      });
    }
  };

  const user = useAuthStore((state) => state.user);

  const deletableFilters = [
    ["close_date_ge", t("deals.expectedCloseDateFrom"), "date"],
    ["close_date_le", t("deals.expectedCloseDateTo"), "date"],
    ["registration_date_ge", t("deals.registrationDate") + " " + t("common.from"), "date"],
    ["registration_date_le", t("deals.registrationDate") + " " + t("common.to"), "date"],
    ["expiration_date_ge", t("deals.expirationDate") + " " + t("common.from"), "date"],
    ["expiration_date_le", t("deals.expirationDate") + " " + t("common.to"), "date"],
    ["vendors", t("deals.vendors"), "vendors"],
    ["fulltext", t("common.fulltext"), "string"],
    ["current_state_id", t("deals.currentState"), "state"],
  ];

  let isFilterFill = false;

  deletableFilters.forEach((deletableFilter) => {
    if (deletableFilter[0] in filter && filter[deletableFilter[0]]) {
      isFilterFill = true;
    }
  });

  if (!isFilterFill) {
    return <></>;
  }

  const stateNames = {
    [-1]: t("deals.rejected"),
    [1]: t("deals.confirmed"),
    [2]: t("deals.closed"),
    [-2]: t("common.cancel"),
    [0]: t("deals.waitingConfirmation"),
  };

  return (
    <div className="d-lg-flex gap-2 py-3 border-bottom">
      {deletableFilters.map(
        (deletableFilter, key) =>
          deletableFilter[0] in filter &&
          filter[deletableFilter[0]] &&
          (!Array.isArray(filter[deletableFilter[0]]) ||
            (Array.isArray(filter[deletableFilter[0]]) &&
              filter[deletableFilter[0]].length > 0)) && (
            <>
              <div className="btn-group" key={key}>
                <button className="btn btn-sm btn-secondary">
                  {deletableFilter[1]}:&nbsp;
                  <strong>
                    {deletableFilter[2] === "string" &&
                        filter[deletableFilter[0]]}

                    {deletableFilter[2] === "date" &&
                      new Date(filter[deletableFilter[0]]).toLocaleDateString()}

                    {deletableFilter[2] === "number" &&
                      number_format(filter[deletableFilter[0]], 2, ",", ".")}

                    {deletableFilter[2] === "vendors" &&
                      user &&
                      user.role &&
                      filter[deletableFilter[0]].map(
                        (vendor_id, vindex) =>
                          (vindex > 0 ? ", " : "") +
                          user.role
                            .find((r) => r.role_id === "vendors")
                            ?.val.find(
                              (vendor) => vendor.vendor_id === vendor_id
                            )?.vendor
                      )}

                    {deletableFilter[2] === "state" && (
                        stateNames[filter[deletableFilter[0]]]
                    )}
                  </strong>
                </button>
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => deleteFromFilter(deletableFilter[0])}
                >
                  <i className="ki-solid ki-trash text-white"></i>
                </button>
              </div>
            </>
          )
      )}
    </div>
  );
}
